import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NadajPrzesylkeType,
  ScreenType,
  SposobNadaniaType,
} from '../../enums/enums';
import { MainOptionButtonComponent } from '../../common/main-option-buttom/main-option-button.component';
import { ShippingCourierFormComponent } from './shipping-courier-form/shipping-courier-form.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { ShippingPointFormComponent } from './shipping-point-form/shipping-point-form.component';
import { PageHeaderComponent } from '../../common/page-header/page-header.component';
import { MainOptionButtonsWrapperComponent } from '../../common/main-option-buttons-wrapper/main-option-buttons-wrapper.component';
import { FormHeaderComponent } from '../../common/form-header/form-header.component';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-shipping-options-page',
  standalone: true,
  imports: [
    CommonModule,
    MainOptionButtonComponent,
    ShippingCourierFormComponent,
    ShippingPointFormComponent,
    PageHeaderComponent,
    MainOptionButtonsWrapperComponent,
    FormHeaderComponent,
  ],
  templateUrl: './shipping-options-page.component.html',
  styleUrl: './shipping-options-page.component.scss',
})
export class ShippingOptionsPageComponent {
  ScreenType = ScreenType;
  SposobNadaniaType = SposobNadaniaType;

  constructor(
    private navigationService: NavigationService,
    protected storeService: StoreService
  ) {}

  isPageActive(): boolean {
    return (
      this.storeService.getScreenType() === ScreenType.OPCJE_NADANIA &&
      this.storeService.getSposobNadaniaStepNumber() === 0
    );
  }

  isShippingPoint(): boolean {
    return (
      this.storeService.getSposobNadaniaTyp() ===
      SposobNadaniaType.NADAJ_W_PUNKCIE
    );
  }

  isShippingCourier(): boolean {
    return (
      this.storeService.getSposobNadaniaTyp() ===
      SposobNadaniaType.ZAMOW_KURIERA
    );
  }

  isLabelReady() {
    return (
      this.storeService.getNadajPrzesylkeTyp() ===
      NadajPrzesylkeType.POSIADAM_ETYKIETE
    );
  }

  sendOnPointButtonAction() {
    this.navigationService.changeSposobNadaniaTo(
      SposobNadaniaType.NADAJ_W_PUNKCIE
    );
  }

  orderCourierButtonAction() {
    this.navigationService.changeSposobNadaniaTo(
      SposobNadaniaType.ZAMOW_KURIERA
    );
  }

  backButtonAction() {
    this.navigationService.changeSposobNadaniaStepNumberTo(0);
    this.navigationService.changeScreenTo(ScreenType.STRONA_GLOWNA);
  }

  changePointButtonAction() {
    this.navigationService.changeSposobNadaniaStepNumberTo(0);
  }
}
